import React from 'react';
export function PromiseSection() {
  return <section className="w-full py-12 md:py-16 px-6 bg-beige text-center" data-id="element-186">
      <div className="max-w-2xl mx-auto" data-id="element-187">
        <p className="font-playfair text-xl md:text-2xl lg:text-3xl text-dark/80 leading-relaxed" data-id="element-188">
          Empieza a entender lo que te pasa en los{' '}
          <span className="text-terracotta font-semibold" data-id="element-189">primeros días</span>…
          <br className="hidden md:block" data-id="element-190" />y{' '}
          <span className="text-terracotta font-semibold" data-id="element-191">deja de repetir</span>{' '}
          patrones antes de lo que crees.
        </p>
      </div>
    </section>;
}